import type { Step, StepsData } from "@/content/schema";

export interface PartGroup {
	label: string;
	code?: string;
	names: string[];
}

/** Names of the parts to highlight/frame for a step (explicit focus list, else the parts that appear). */
export function focusNames(step: Step): string[] {
	return [
		...new Set([...(step.focus ?? []), ...step.parts.map((p) => p.name)]),
	];
}

/** Groups the step's parts by label ("10093081 fourreau ×11"), extracting the IKEA reference as `code`. */
export function partGroups(
	step: Step,
	labels: StepsData["labels"],
): PartGroup[] {
	const groups = new Map<string, PartGroup>();
	for (const name of focusNames(step)) {
		const part = step.parts.find((p) => p.name === name);
		const label = labels[name] ?? (part?.ref || name);
		const m = label.match(/^([\d/ ]+\d)\s+(.*)$/);
		const g = groups.get(label) ?? {
			label: m?.[2] ?? label,
			code: m?.[1],
			names: [],
		};
		g.names.push(name);
		groups.set(label, g);
	}
	return [...groups.values()];
}
